import { render, staticRenderFns } from "./BranchListTable.vue?vue&type=template&id=af1398fe&scoped=true"
import script from "./BranchListTable.vue?vue&type=script&lang=js"
export * from "./BranchListTable.vue?vue&type=script&lang=js"
import style0 from "./BranchListTable.vue?vue&type=style&index=0&id=af1398fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af1398fe",
  null
  
)

export default component.exports